export class SupplierWorktimeActivity {
    public userID: string;
    public setWorkTimeActive: boolean;
    public timestamp?: string;
    public lat?: number;
    public long?: number;
}
